
export const TiposDocumental = [
{
    titulo:"Formulario de inscripción de empresa.",
    tipoDocumental:"Contrato",
    tipoCliente:["EA","DE"]
},
{
    titulo:"Copia del documento de identidad del contratante o del representante legal.",
    tipoDocumental:"Documento de identidad", 
    tipoCliente:["EA","DE"]
},
{
    titulo:"Copia del RUT.",
    tipoDocumental:"RUT", 
    tipoCliente:["EA","DE"]
},
{
    titulo:"Copia de los pagos (PILA) de los últimos 3 periodos.",
    tipoDocumental:"Contrato", 
    tipoCliente:["EA","DE"]
},
{
    titulo:"Carta de desafiliación con sello de la anterior ARL.",
    tipoDocumental:"Contrato", 
    tipoCliente:["EA","DE"]
},
{
    titulo:"Otros anexos.",
    tipoDocumental:"Contrato", 
    tipoCliente:["EA","DE","VI"]
},
{
    titulo:"Formulario de inscripción de independiente voluntario.",
    tipoDocumental:"Contrato", 
    tipoCliente:["VI"]
},
{
    titulo:"Examen pre-ocupacional.",
    tipoDocumental:"Certificado medico ocupacional", 
    tipoCliente:["VI"]
},
{
    titulo:"Copia del documento de identidad del independiente voluntario.",
    tipoDocumental:"Documento de identidad", 
    tipoCliente:["VI"]
},
{
    titulo:"Certificado de afiliación a EPS.",
    tipoDocumental:"Soportes", 
    tipoCliente:["VI"]
},
{
    titulo:"Certificado de afiliación a AFP.", 
    tipoDocumental: "Soportes", 
    tipoCliente:["VI"]
},
{
    titulo:"Formulario de inscripción de contratante no afiliado.",
    tipoDocumental:"Contrato", 
    tipoCliente:["PS"]
},
{
    titulo:"Certificado de existencia y representación legal o su equivalente.",
    tipoDocumental:"Certificado de existencia legal", 
    tipoCliente:["PS","EA","DE"]
},
{
    titulo:"Cámara de comercio con vigencia no superior a 90 días.",
    tipoDocumental:"Certificado de existencia legal", 
    tipoCliente:["PS"]
},
{
    titulo:"Copia del documento de identidad del representante legal.",
    tipoDocumental:"Documento de identidad", 
    tipoCliente:["PS"]
},
{
    titulo:"Contrato por prestación de servicios.",
    tipoDocumental:"Contrato", 
    tipoCliente:["PS"]
}
];

export const mimePdf = [
    'application/pdf',
    'application/x-pdf',
    'application/acrobat',
    'applications/vnd.pdf',
    'application/x-download',
    ​'application/download',
    'text/pdf',
    'text/x-pdf'
];
 
export const obtenerMimePdf = (mime: String) => {
    return mimePdf.find(mimetype => mimetype === mime);
};

export const obtenerTipoDocumental = (titulo: string) => {
    let busqueda = TiposDocumental.find(td => td.titulo === titulo);
    return busqueda ? busqueda : { titulo : titulo ,tipoDocumental: titulo };
};
    


// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/modelo/TiposDocumental.ts